<template lang="jade">
  section#page-container.initial(transition="nav")
    a.target-section(v-for="target in targets" v-link="target.link" v-bind:style="{ backgroundImage: 'url(' + target.background + ')' }")
      .title
        h1 {{target.sub}}
      .image
        img(v-bind:src="target.img")
</template>

<script>
  export default {
    data () {
      return {
        activedlink: true,
        home_headline: "imgs/logos/hdr-headline.svg",
        targets: [
          {
            title: "content creators",
            sub: "i am",
            img: "imgs/slice/head-01.png",
            background: "imgs/slice/bg-01.jpg",
            link: "/content-creators"
          },
          {
            title: "content owners",
            sub: "i own",
            img: "imgs/slice/head-02.png",
            background: "imgs/slice/bg-02.jpg",
            link: "/content-owners"
          },
          {
            title: "content distributors",
            sub: "i deliver",
            img: "imgs/slice/head-03.png",
            background: "imgs/slice/bg-03.jpg",
            link: "/content-distributors"
          },
          {
            title: "ce manufacturers",
            sub: "your hardware",
            img: "imgs/slice/head-04.png",
            background: "imgs/slice/bg-04.jpg",
            link: "/ce-manufacturers"
          },
          {
            title: "ce distributors",
            sub: "the chip",
            img: "imgs/slice/head-05.png",
            background: "imgs/slice/bg-05.jpg",
            link: "/ce-distributors"
          },
          {
            title: "consumers",
            sub: "you",
            img: "imgs/slice/head-06.png",
            background: "imgs/slice/bg-06.jpg",
            link: "/consumers"
          }
        ]
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>
  
  @import "../_sass/utilities/_utilities.sass"

  section#page-container
    .image
      @extend %smooth
      height: 100%
      width: 100%
      position: absolute
      top: 0
      left: 0
      z-index: 0
      -webkit-filter: grayscale(100%);
      img
        height: 100%
        position: relative
        display: block
        margin: 0 auto
        width: initial
    
    .title
      @extend %smooth
      @extend %aligner-vertical
      position: absolute
      height: 100%
      padding-left: 3rem
      z-index: 10
      h1
        @extend %smooth
        text-transform: uppercase
        font-weight: 300
        font-size: 2.85rem
        letter-spacing: 2px!important
        color: $dk-grey
        letter-spacing: 0
        &:after
          content: ""
          display: block
          background-size: 55%
          background-repeat: no-repeat
          background-position-y: 50%
          background-position-x: 50%
          display: inline-block
          height: 2.125rem
          width: 3rem
          margin-left: .5rem
          opacity: 0
  
    // NAVIGATION

    a.target-section
      @extend %smooth
      box-shadow: 0 0 20px rgba(0,0,0,.5)
      display: block
      width: 100vw
      position: relative
      float: left
      overflow: hidden
      background-size: cover
      background-repeat: no-repeat
      background-position-x: center
      cursor: pointer
      opacity: 1
      &:hover
        .image
          -webkit-filter: grayscale(0%);
        .title
          h1:after
            opacity: 1
            margin-left: 1rem

  .nav-enter,
  .nav-leave
    opacity: 0
    a.target-section
      opacity: 0!important
    a.target-section:nth-child(1)
      left: 100vw
    a.target-section:nth-child(2)
      right: 100vw
    a.target-section:nth-child(3)
      left: 100vw
    a.target-section:nth-child(4)
      right: 100vw
    a.target-section:nth-child(5)
      left: 100vw
    a.target-section:nth-child(6)
      right: 100vw
  
  // individual slice styling
  a.target-section:nth-child(1)
    height: 16.667%
    background-position-y: 15%
    left: 0
    h1
      color: $lt-purple!important
      &:after
        background-image: url('../imgs/icons/section-arrow-1.svg')

  a.target-section:nth-child(2)
    height: 16.667%
    background-position-y: 30%
    right: 0
    h1
      color: $med-purple!important
      &:after
        background-image: url('../imgs/icons/section-arrow-2.svg')

  a.target-section:nth-child(3)
    height: 16.667%
    background-position-y: 45%
    left: 0
    h1
      color: $lime!important
      &:after
        background-image: url('../imgs/icons/section-arrow-3.svg')

  a.target-section:nth-child(4)
    height: 23.5%
    background-position-y: 60%
    right: 0
    h1
      color: $orange!important
      &:after
        background-image: url('../imgs/icons/section-arrow-4.svg')

  a.target-section:nth-child(5)
    height: 9.85%
    background-position-y: 75%
    left: 0
    h1
      color: $lt-green!important
      &:after
        background-image: url('../imgs/icons/section-arrow-5.svg')

  a.target-section:nth-child(6)
    height: 16.85%
    background-position-y: 90%
    right: 0
    h1
      color: $lt-blue!important
      &:after
        background-image: url('../imgs/icons/section-arrow-6.svg')


</style>


/** WEBPACK FOOTER **
 ** Nav.vue?38dfcf7c
 **/